module.exports = __webpack_public_path__ + "static/Bosk.ttf-9abe24868d1340cf166bd6d4cbd4087a.eot";